import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { isPlatformBrowser } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class IconService {
  private readonly matIconRegistry = inject(MatIconRegistry);
  private readonly domSanitizer = inject(DomSanitizer);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly iconPaths = new Map<string, string>([
    ['token-engine', '/assets/icons/common/token-engine.svg'],
    ['launchpad', '/assets/icons/common/launchpad-icon.svg'],
    ['dex', '/assets/icons/common/dex-icon.svg'],
    ['dao', '/assets/icons/common/dao-icon.svg'],
    ['academy', '/assets/icons/common/academy-icon.svg'],
    ['blog', '/assets/icons/common/blog-icon.svg'],
    ['help-centre', '/assets/icons/common/help-centre-icon.svg'],
    ['about-us', '/assets/icons/common/about_us.svg'],
    ['career', '/assets/icons/common/career.svg'],
    ['abc', '/assets/icons/common/carbon_search.svg'],
    ['bell', '/assets/icons/common/bell.svg'],
    ['close', '/assets/icons/common/close.svg'],
    ['chart1', '/assets/icons/common/chart1.svg'],
    ['flash', '/assets/icons/common/flash.svg'],
    ['category', '/assets/icons/common/category.svg'],
    ['document', '/assets/icons/common/document.svg'],
    ['blend', '/assets/icons/common/blend.svg'],
    ['graph', '/assets/icons/common/graph.svg'],
    ['profile2user', '/assets/icons/common/profile2user.svg'],
  ]);
  private readonly emptyIconLiteral = this.domSanitizer.bypassSecurityTrustHtml(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"></svg>',
  );

  registerIcons(): void {
    const isBrowser = isPlatformBrowser(this.platformId);

    for (const [name, path] of this.iconPaths) {
      if (isBrowser) {
        this.matIconRegistry.addSvgIcon(
          name,
          this.domSanitizer.bypassSecurityTrustResourceUrl(path),
        );
      } else {
        this.matIconRegistry.addSvgIconLiteral(name, this.emptyIconLiteral);
      }
    }
  }
}
